import React, { FC, useState } from 'react';
import cn from 'classnames';
import Collapse, { CollapseProps } from 'antd/lib/collapse';
import 'antd/lib/collapse/style/index.css';
import Title from '../Title';
import Icon from '../Icon';
import style from './style.module.scss';

type CarEquipmentProps = {
  list?: { title: string; items: string[] }[];
  title: string;
};

const CarEquipment: FC<CarEquipmentProps> = ({ list, title }) => {
  const [activeKeys, setActiveKeys] = useState<CollapseProps['activeKey']>([]);
  const isSomePanelActive =
    (Array.isArray(activeKeys) && activeKeys.length) ||
    typeof activeKeys === 'string';

  function toggle() {
    if (isSomePanelActive) {
      setActiveKeys([]);
    } else {
      setActiveKeys(list?.map(item => item.title));
    }
  }

  return list ? (
    <div className={cn(style.wrap, 'mb-5')}>
      <header className={style.header}>
        <Title className="mb-0" tag="h2">
          {title}
        </Title>
        <button type="button" onClick={toggle} className={style.toggle}>
          <span className="d-none d-sm-inline">
            {isSomePanelActive ? 'Свернуть всё' : 'Развернуть всё'}
          </span>
          <Icon
            name="circled-angle"
            className={cn(style.toggleIcon, {
              [style.toggleIconUp]: isSomePanelActive,
            })}
          />
        </button>
      </header>
      <Collapse
        expandIconPosition="right"
        className={style.collapse}
        onChange={setActiveKeys}
        activeKey={activeKeys}
      >
        {list.map(({ title: itemTitle, items }) => (
          <Collapse.Panel key={itemTitle} header={itemTitle}>
            <ul>
              {items?.map(equipment => (
                <li key={equipment}>{equipment}</li> // TODO: Добавить разбивку по колонками и css-modules
              ))}
            </ul>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  ) : null;
};

export default CarEquipment;
